// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const UserProvider = registerClientReference(
    function() { throw new Error("Attempted to call UserProvider() from the server but UserProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/shared/lib/UserContext.tsx",
    "UserProvider",
);
export const useUser = registerClientReference(
    function() { throw new Error("Attempted to call useUser() from the server but useUser is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/shared/lib/UserContext.tsx",
    "useUser",
);
